import { createSvgIcon } from '@mui/material/utils';
import React from 'react';

export const LogOutDoor = createSvgIcon(
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.66663 2H12.6666V8.66667"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinejoin="round"
    />
    <path
      d="M8.22205 12.6667H15.3334"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinejoin="round"
    />
    <path
      d="M12.6666 15.3333L15.3333 12.6667L12.6666 10"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinejoin="round"
    />
    <path
      d="M6.66669 15.3334L0.666687 14V2.00002L6.66669 0.666687V15.3334Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinejoin="round"
    />
    <path
      d="M4.16671 8.83335C4.62695 8.83335 5.00004 8.46029 5.00004 8.00002C5.00004 7.53975 4.62695 7.16669 4.16671 7.16669C3.70647 7.16669 3.33337 7.53975 3.33337 8.00002C3.33337 8.46029 3.70647 8.83335 4.16671 8.83335Z"
      fill="currentColor"
    />
  </svg>,
  'LogOutDoor'
);
